import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Golf from "../../../assets/img/SolutionsIcons/AgilysysGolf.svg";
import { Header } from "../../../components/Header";

const GolfFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return (
      <div className="page splash golfFPage">
        <div className="page-title">
          <img src={Golf} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            A modern cloud-native pro shop & course management solution for Life
            Plan Community courses.
            {"\n\n"}
          </div>
          <div className="std-text">
            Whether you're organizing tournaments, scheduling and tracking tee
            times, managing the pro shop, directing staff or overseeing player
            experiences, Agilysys Golf provides reliable property and golf
            management efficiency.{"\n\n"}
          </div>
          <div className="std-text">
            Since it integrates seamlessly with PMS solutions, it’s easy to
            share data across the enterprise; accessing player data including
            personal preferences, play histories and handicaps.
          </div>
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - Golf", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/golf.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveGolf.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default GolfFPage;